<form [formGroup]="form" (ngSubmit)="authorize()">
    <h1 mat-dialog-title>Autorización</h1>
    <div mat-dialog-content>
        <mat-form-field class="full-width">
            <input #pass type="text" matInput placeholder="Contraseña" formControlName="Password" required>
            <mat-error *ngIf="f.Password.errors && f.Password.errors.required">
                Ingrese la contraseña
            </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width">
            <textarea matInput formControlName="Observations" placeholder="Observaciones"></textarea>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div class="pull-right">
            <button mat-button type="submit">Autorizar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar autorización</button>
        </div>
    </div>
</form>